import { render, staticRenderFns } from "./CustomDesign.vue?vue&type=template&id=cdbfa92e&scoped=true&"
import script from "./CustomDesign.vue?vue&type=script&lang=js&"
export * from "./CustomDesign.vue?vue&type=script&lang=js&"
import style0 from "./CustomDesign.vue?vue&type=style&index=0&id=cdbfa92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbfa92e",
  null
  
)

export default component.exports